import axios from 'axios';
import { baseUrl } from './baseUrls';

function handleResponse(response){
  if(response.status === 200){
    return response;
  }
  return response;
}
function handleCatch(err){
  if(err.response && err.response.status === 401){
    localStorage.clear();
    window.location.reload();
  }
  throw err;
}
export default function request(url,options){
  return axios(`${baseUrl}${url}`,options)
    .then((response) => handleResponse(response))
    .catch((err) => handleCatch(err))
}
